import { BASE_URL } from "./connectionUrl";

export const downloadTemplate = async (token, type) => {
    try {
        const response = await fetch(
            `${BASE_URL}/api/v1/admin/reports/download_template/${type}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );

        if (!response.ok) throw new Error("Download failed");

        // Convert response into a CSV File & force download
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${type}.csv`;
        a.click();

        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error(error);
    }
};
